import { render } from "./MField.vue?vue&type=template&id=56765630"
import script from "./MField.vue?vue&type=script&lang=js"
export * from "./MField.vue?vue&type=script&lang=js"

import "./MField.vue?vue&type=style&index=0&id=56765630&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__